var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-btn',{staticClass:"formstep-btn t-btn--x-large",attrs:{"id":_vm.id,"type":_vm.type,"color":"primary"},on:{"click":_vm.onClick}},[_vm._t("before"),_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }